import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IFormUUID } from "../../../models/nominals";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { WriteReviewFormMode } from "../constants";
import { setWriteReviewFormMode } from "../reducers";
import { getWriteReviewFormHTMLID, getWriteReviewFormMode } from "../selectors";

type IProps = Immutable<{
    formUUID: IFormUUID;
}>;

export const WriteReviewButton = (props: IProps): React.ReactNode => {
    const dispatch = useAppDispatch();
    const displayMode = useAppSelector((state) =>
        getWriteReviewFormMode(state.reviews, props),
    );

    const onClick = () => {
        const newMode =
            displayMode === WriteReviewFormMode.FORM_OPEN
                ? WriteReviewFormMode.CLOSED
                : WriteReviewFormMode.FORM_OPEN;
        dispatch(
            setWriteReviewFormMode({
                formUUID: props.formUUID,
                mode: newMode,
            }),
        );
    };

    if (displayMode === WriteReviewFormMode.THANK_YOU_OPEN) {
        return null;
    }

    return (
        <button
            aria-expanded={displayMode === WriteReviewFormMode.FORM_OPEN}
            aria-controls={getWriteReviewFormHTMLID(props.formUUID)}
            className="customer-review__button button button--rock-blue"
            onClick={onClick}
        >
            <span className="customer-review__button__link">
                <span className="customer-review__button__icon"></span>
                {t`WRITE A REVIEW`}
            </span>
        </button>
    );
};
